import React, { createContext, useState, useContext, useCallback } from 'react';

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [teams, setTeams] = useState([]);
  const [resources, setResources] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [jobTypes, setJobTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const updateTeams = useCallback((newTeams) => {
    setTeams(newTeams);
  }, []);

  const updateResources = useCallback((newResources) => {
    setResources(newResources);
  }, []);

  const updateTasks = useCallback((newTasks) => {
    setTasks(newTasks);
  }, []);

  const updateJobTypes = useCallback((newJobTypes) => {
    setJobTypes(newJobTypes);
  }, []);

  const setLoaderState = useCallback((isLoading) => {
    setLoading(isLoading);
  }, []);

  const setErrorState = useCallback((errorMsg) => {
    setError(errorMsg);
  }, []);

  return (
    <AppContext.Provider
      value={{
        teams,
        resources,
        tasks,
        jobTypes,
        loading,
        error,
        updateTeams,
        updateResources,
        updateTasks,
        updateJobTypes,
        setLoaderState,
        setErrorState,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useApp = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useApp must be used within AppProvider');
  }
  return context;
};
